// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__1XcRn","success":"Toast_success__1GdFV","error":"Toast_error__27ODz","info":"Toast_info__3q63m","warning":"Toast_warning__3nRdq","close":"Toast_close__LWfTJ"};